import * as React from 'react';

var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgThumbsUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    width: 16,
    height: 16
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#thumbs-up_svg__clip0_8_5523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.667 14.667h-2a1.333 1.333 0 01-1.334-1.333V8.667a1.333 1.333 0 011.334-1.333h2M9.333 6V3.333a2 2 0 00-2-2l-2.666 6v7.334h7.52a1.333 1.333 0 001.333-1.133l.92-6A1.333 1.333 0 0013.107 6H9.333z",
    stroke: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "thumbs-up_svg__clip0_8_5523"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  })))));
}

export { SvgThumbsUp as default };
//# sourceMappingURL=thumbs-up.svg.js.map
